import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { AppLoaderComponent } from './app-loader.component';
import { AppLoaderInterceptor } from './app-loader.interceptor';
import { AppLoaderService } from './app-loader.service';
import { CoreService } from './core.service';
import { Footer1Component } from './footer1/footer1.component';
import { Footer2Component } from './footer2/footer2.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    AppLoaderComponent,
    HeaderComponent,
    Footer1Component,
    Footer2Component,
    FooterComponent
  ],
  exports: [
    AppLoaderComponent,
    HeaderComponent,
    Footer1Component,
    Footer2Component,
    FooterComponent
  ]
})
export class CoreModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: CoreModule,
      providers: [
        CoreService,
        AppLoaderService,
        { provide: HTTP_INTERCEPTORS, useClass: AppLoaderInterceptor, multi: true }
      ]
    };
  }
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    //   throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }
}
